module.exports = function (data) {
    return {
        event: 'BWSlinkClick',
        eventContext: {
            linkType: data.linkType || 'chatbot',
            linkName: data.linkName || `web:chatbot:${data.text}:cta:${data.cta}`
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/bwsbot/atmmapper/bws-bot-link-click-mapper.js
 **/